import Certifications from "./certifications";
import Partners from "./partners";
import Process from "./process";
import Production from "./production";
import Reporting from "./reporting";
import Projections from "./projections";

export default [...Partners, ...Process, ...Certifications, ...Production, ...Projections, ...Reporting];
